import React from 'react'
import { Button, IconCloseDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { PROMO_I18N_NAMESPACE } from '../../../lib/constants'
import classes from './CloseButton.module.scss'

export const CloseButton = ({ closeModal }: { closeModal: () => void }) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <Button
      className={`mc-modal__close mc-p-0 mc-m-3 ${classes.close}`}
      kind='link'
      onClick={closeModal}
    >
      <IconCloseDefault
        size={2}
        className='mc-text-color--dark'
        srText={t('common.promoExplainerModal.closeButtonAlt')}
        alt={t('common.promoExplainerModal.closeButtonAlt')}
      />
    </Button>
  )
}
